import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';

import {Modal, message, Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}
const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {
        key: 'orgName', width: 100,
        label: '所属部门'
    },
    {
        key: 'objectCode', width: 100,
        label: '对象编号'
    },
    {
        key: 'objectName', width: 100,
        label: '对象名称'
    },
    {
        key: 'objectType', width: 100,
        label: '对象类型',
        render: (data) => {
            var objectType = JSON.parse(data)
            if(objectType==0){
                return '专业';
            }else if(objectType==1){
                return '教师';
            }else if(objectType==2){
                return '课程';
            }else if(objectType==3){
                return '班级';
            }else if(objectType==4){
                return '学生';
            }else if(objectType==5){
                return '部门';
            }else if(objectType==6){
                return '团队';
            }else {
                return '未知类型';
            }
        } 
    },
    {key:'targetCategory', label: '诊改分类'},
    {key:'targetName', label: '诊改指标'},
    {key:'resultScore', label: '录入总分'},
    {key:'orgAuditScore', label: '审核得分'},
    {key:'submitEmployeeName', label: '录入人'},
    {key:'orgResultState', label: '院部审核状态', width: 120, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>待提交</Tag>)},
    {key:'resultState', label: '校级审核状态', width: 120, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>未开始</Tag>)},
    {key:'resultDesc', label: '结果描述'}
]
const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
])

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    //获取审核配置名称
    fetch.post('zgcp/org/audit/getAuditName/'+keywords['targetId'])
    .then(response => {
        const auditNames = response.payload.data;
        for(let i = 0; i < columnsArray.length; i++) {
            if(columnsArray[i].key == 'orgAuditScore'){
                columnsArray[i].label = auditNames[0]+'分数'
            }
            if(columnsArray[i].key == 'orgResultState'){
                columnsArray[i].label = auditNames[0]+'状态'
            }
            if(columnsArray[i].key == 'auditScore'){
                columnsArray[i].label = auditNames[1]+'分数'
            }
            if(columnsArray[i].key == 'resultState'){
                columnsArray[i].label = auditNames[1]+'状态'
            }
        }
    })
    return fetch.post('zgcp/single/org/auditresult/query?'+ params.join('&'), newKeyword)
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = []
        
        for (let i = 0; i < columnsArray.length; i++) {
            if (columnsArray[i].key != 'className' && columnsArray[i].key != 'objectCode') {
                newArray.push(columnsArray[i])
            }
            if ((extParams.objectType == 4 || extParams.objectType == 1) && columnsArray[i].key == 'objectCode') {
                newArray.push(columnsArray[i])
            }
            if (extParams.objectType == 4 && columnsArray[i].key == 'className') {
                newArray.push(columnsArray[i])
            }
            if(extParams){
                if (i === 13) {
                    if (extParams.infoOptions && extParams.infoOptions.length > 0) {
                        extParams.infoOptions.forEach(o => {
                            var key = o.name;
                            if(key.indexOf("FILEVO-") != -1){
                                newArray.push({
                                    key: o.name,
                                    label: o.value, 
                                    width: 120,
                                    render: (files) => {
                                        if(files && files.length > 0) {
                                            return (
                                                <ol className="upper-alpha">
                                                    {
                                                        files.map((file) => (
                                                            <li><a href={window.base + 'zgcp/enter/file/download?id=' + file.id} target="_blank">{ file.fileName }</a></li>
                                                        ))
                                                    }
                                                </ol>
                                            )
                                        }
                                        return "无";
                                    }
                                })
                            }else{
                                newArray.push({
                                    key: o.name,
                                    label: o.value, 
                                    width: 120
                                })
                            }
                        })
                    }
                }
                if (i === 7) {
                    if (extParams.options && extParams.options.length > 0) {
                        extParams.options.forEach(o => {
                            newArray.push({
                                key: o.name,
                                label: o.value, 
                                width: 120
                            })
                        })
                    }
                }
            }
        }
        return {
            data: response.payload.data,
            meta: response.payload.meta,
            headers: utils.columns(columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: res.data.dataList || [],
        selects: (res.data.dataList || []).map((d,i) => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('zgcp/single/org/auditresult/get/'+ id, {})
    .then(response => {
        return response;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('zgcp/single/org/auditresult/remove', ids)
    .then(response => {
        return response;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                callback();
                            },
                        })
                    }
                    ;
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'jszgsubresult'+ url;
};

/**
 * @method batchBack
 * @return {promise}
 */
 const batchBack = (callback) => {
    return fetch.post('zgcp/single/org/auditresult/batch/back', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }

        callback();
        return response;
    });
}

/**
 * @method batchSubmit
 * @return {promise}
 */
 const batchSubmit = (callback) => {
    return fetch.post('zgcp/single/org/auditresult/batch/submit', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }
        callback();
    });
}

const auditInsert = (domain) => {
    return fetch.post('zgcp/single/org/auditresult/insert' , domain)
    .then(response =>{
        return response
    })
}

export default {
    querySearch,
    querySearchById,
    batchBack,
    download: fetch.base + 'zgcp/enter/file/download?id=',
    remove,
    headers,
    onSelect,
    batchSubmit,
    auditInsert,
    batchRemove,
    setRefresh,
    redirect,
    getSelection,
}
